module.exports = __webpack_public_path__ + "img/Dash_mini_whatsapp.f1660496.svg";